import { useState } from 'react';
import { saveAs } from 'file-saver';

import { MutateFileDownload } from '../types/mutateFunction';
import { parseQueryString } from '../components/PdfViewer/queryString';
import { useViewerRoute } from '../contexts/ViewerRoute';

const useDownloadPdfFile = () => {
  const { historyId } = useViewerRoute();
  const [isLoading, setIsLoading] = useState(false);

  const downloadPdfFile = async (
    downloadUrl: string,
    fileName: string,
    mutateFileDownload: MutateFileDownload,
  ) => {
    try {
      setIsLoading(true);
      const response = await fetch(downloadUrl);

      if (!response.ok) {
        alert('다운로드에 실패했습니다.');
        setIsLoading(false);
        return;
      }

      if (typeof historyId === 'string') {
        mutateFileDownload(
          {
            historyId: parseQueryString(historyId),
          },
          {
            onSuccess: async () => {
              const blob = await response.blob();

              const ua = navigator.userAgent || '';
              const isFacebookWebView = /FBAN|FBAV|Instagram/.test(ua);

              if (isFacebookWebView) {
                alert(
                  '앱에서 다운로드가 차단되어 있습니다. Safari나 Chrome에서 다시 시도해 주세요.',
                );
                setIsLoading(false);
                return;
              }

              try {
                saveAs(blob, `${fileName}.pdf`);
              } catch (e) {
                alert(
                  '다운로드가 차단되었습니다. Safari나 Chrome에서 다시 시도해 주세요.',
                );
              }
            },
            onError: () => {
              alert(
                '다운로드에 실패했습니다. Safari나 Chrome에서 다시 시도해 주세요.',
              );
            },
            onSettled: () => {
              setIsLoading(false);
            },
          },
        );
      }
    } catch (e) {
      alert('다운로드에 실패했습니다. Safari나 Chrome에서 다시 시도해 주세요.');
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    downloadPdfFile,
  };
};

export default useDownloadPdfFile;
